import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { GenericFilter } from './generic_filter';
import { YearFilter as YearFilterInput } from '../../components/search_filters/filters/year_filter';

import { setYear, setDirty } from '../../redux/modules/search/year';

import { IYear } from '../../models/filters/year';

interface IProps {
  year: IYear;
  dispatch: Dispatch<any>;
}

class YearFilter extends GenericFilter<IProps> {
  protected setDirty(isDirty: boolean) {
    this.props.dispatch(setDirty(isDirty));
  }

  public render() {
    return (
      <YearFilterInput
        values={this.props.year.years}
        onChange={(values: string[]) => this.props.dispatch(setYear(values))}
      />
    );
  }
}

const YearFilterWrapper = connect((state: { year: IYear }) => ({
  year: state.year,
}))(YearFilter as any);

export { YearFilterWrapper as YearFilter, YearFilter as YearFilterClass};
